var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "myFooter"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('h5', [_vm._v("About")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/mubaidr/Book-Trading-Club#Book-Trading-Club"
    }
  }, [_vm._v("Service")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/mubaidr/Book-Trading-Club"
    }
  }, [_vm._v("Source Code")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h5', [_vm._v("Support")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/mubaidr/Book-Trading-Club/issues"
    }
  }, [_vm._v("Github Issues")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', [_vm._v("Designed and Coded by "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://mubaidr.github.io"
    }
  }, [_vm._v("Muhammad Ubaid Raza")])])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6644a488","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/footer.vue
// module id = 107
// module chunks = 0